"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const vault_1 = require("../../api/vault");
const configuration_1 = __importDefault(require("../../common/js/apis/configuration/vault/configuration"));
const noop_1 = require("../../common/js/helper/noop");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
class DelegationStore {
    api = new vault_1.DelegationApi(configuration_1.default);
    internalLoading = false;
    get isLoading() {
        return this.internalLoading;
    }
    updateDelegationAndRefreshToken(customerId) {
        this.internalLoading = true;
        return this.updateDelegation(customerId)
            .then(() => {
            if (!AuthorizationStore_1.default.auth0?.isAuthenticated) {
                return Promise.reject();
            }
            // Refreshing access token for the correct permission after switch company.
            return AuthorizationStore_1.default.auth0.getAccessTokenSilently({ ignoreCache: true });
        })
            .then(noop_1.noop)
            .finally(() => {
            this.internalLoading = false;
            document.dispatchEvent(new Event('ZndDelegation'));
        });
    }
    updateDelegation(customerId) {
        return this.api.delegate({ delegationModel: { customerId: customerId } });
    }
}
__decorate([
    mobx_1.observable
], DelegationStore.prototype, "internalLoading", void 0);
__decorate([
    mobx_1.computed
], DelegationStore.prototype, "isLoading", null);
__decorate([
    bind_decorator_1.default
], DelegationStore.prototype, "updateDelegationAndRefreshToken", null);
__decorate([
    bind_decorator_1.default
], DelegationStore.prototype, "updateDelegation", null);
exports.default = new DelegationStore();
